<template>
    <v-menu v-model="menuAltro" offset-y left :close-on-content-click="false" min-width="280">
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="mt-1 ml-3" small icon v-bind="attrs" v-on="on" v-tooltip.bottom="'Altre azioni'"
                :color="filtriAttivi ? 'primary' : ''">
                <v-badge v-if="filtriAttivi" color="primary" dot overlap>
                    <v-icon>more_vert</v-icon>
                </v-badge>
                <v-icon v-else>more_vert</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-list dense class="py-1">
                <v-list-item @click="$emit('refresh'); menuAltro = false">
                    <v-list-item-icon class="mr-3">
                        <v-icon small>refresh</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="body-2">Aggiorna</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="role === 'admin'" @click="$emit('esportaExcel'); menuAltro = false">
                    <v-list-item-icon class="mr-3">
                        <v-icon small>grid_on</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="body-2">Esporta Excel</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="role === 'admin'" class="px-4">
                    <v-select :items="filtriUtenti" v-model="localFiltroUtenteSel" label="Utente" hide-details dense
                        @change="$emit('refresh')" />
                </v-list-item>
            </v-list>

            <v-divider />
            <v-card-title class="pb-1 pt-3 px-4" style="font-size:13px !important; font-weight:600;">
                Filtri visualizzazione
            </v-card-title>
            <v-divider />

            <v-list dense class="py-1">

                <!-- Mostra ore -->
                <v-list-item class="px-4">
                    <v-list-item-action class="mr-3 my-0">
                        <v-switch v-model="localMostraOre" hide-details dense color="primary"
                            @change="$emit('refresh')" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="body-2">Mostra ore</v-list-item-title>
                        <v-list-item-subtitle style="font-size:11px;">Registro ore lavorate</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="my-auto ml-2">
                        <v-icon small :color="localMostraOre ? 'primary' : 'grey lighten-1'">schedule</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <!-- Mostra attività -->
                <v-list-item class="px-4">
                    <v-list-item-action class="mr-3 my-0">
                        <v-switch v-model="localMostraTask" hide-details dense color="teal"
                            @change="$emit('refresh')" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="body-2">Mostra attività</v-list-item-title>
                        <v-list-item-subtitle style="font-size:11px;">Appuntamenti, riunioni,
                            note</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="my-auto ml-2">
                        <v-icon small :color="localMostraTask ? 'teal' : 'grey lighten-1'">task_alt</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-divider class="my-1" />

                <!-- Attività completate — sub-filtro, disabilitato se mostraTask è off -->
                <v-list-item class="px-4" :disabled="!localMostraTask">
                    <v-list-item-action class="mr-3 my-0">
                        <v-switch v-model="localMostraCompletate" hide-details dense color="green"
                            :disabled="!localMostraTask" @change="$emit('refresh')" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="body-2" :class="!localMostraTask ? 'grey--text text--lighten-1' : ''">
                            Attività completate
                        </v-list-item-title>
                        <v-list-item-subtitle style="font-size:11px;">
                            Solo per le attività
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="my-auto ml-2">
                        <v-icon small :color="localMostraCompletate && localMostraTask ? 'green' : 'grey lighten-1'">
                            done_all
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <!-- Promemoria — sub-filtro, disabilitato se mostraTask è off -->
                <v-list-item class="px-4" :disabled="!localMostraTask">
                    <v-list-item-action class="mr-3 my-0">
                        <v-switch v-model="localMostraPromemoria" hide-details dense color="blue-grey"
                            :disabled="!localMostraTask" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="body-2" :class="!localMostraTask ? 'grey--text text--lighten-1' : ''">
                            Mostra promemoria
                        </v-list-item-title>
                        <v-list-item-subtitle style="font-size:11px;">
                            Attività senza orario
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="my-auto ml-2">
                        <v-icon small
                            :color="localMostraPromemoria && localMostraTask ? 'blue-grey' : 'grey lighten-1'">
                            notifications
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>

            </v-list>

            <v-divider />
            <v-card-actions class="px-4 py-2">
                <v-btn x-small text color="grey" @click="resetFiltri">Ripristina tutti</v-btn>
                <v-spacer />
                <v-btn x-small text color="primary" @click="menuAltro = false">Chiudi</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    props: {
        role: String,
        filtriUtenti: Array,
        filtroUtenteSel: String,
        mostraCompletate: Boolean,
        mostraPromemoria: { type: Boolean, default: true },
        mostraOre: { type: Boolean, default: true },
        mostraTask: { type: Boolean, default: true },
    },

    data: () => ({
        menuAltro: false,
    }),

    computed: {
        filtriAttivi() {
            return !this.mostraOre || !this.mostraTask || this.mostraCompletate || !this.mostraPromemoria;
        },

        localFiltroUtenteSel: {
            get() { return this.filtroUtenteSel; },
            set(v) { this.$emit('update:filtroUtenteSel', v); },
        },
        localMostraCompletate: {
            get() { return this.mostraCompletate; },
            set(v) { this.$emit('update:mostraCompletate', v); },
        },
        localMostraPromemoria: {
            get() { return this.mostraPromemoria; },
            set(v) { this.$emit('update:mostraPromemoria', v); },
        },
        localMostraOre: {
            get() { return this.mostraOre; },
            set(v) { this.$emit('update:mostraOre', v); },
        },
        localMostraTask: {
            get() { return this.mostraTask; },
            set(v) { this.$emit('update:mostraTask', v); },
        },
    },

    methods: {
        resetFiltri() {
            this.$emit('update:mostraOre', true);
            this.$emit('update:mostraTask', true);
            this.$emit('update:mostraCompletate', false);
            this.$emit('update:mostraPromemoria', true);
            this.$emit('refresh');
        },
    },
};
</script>
